var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.kst0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.kst1{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:currentColor;stroke-width:10.4252;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.kst2{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\r\n\t.kst3{fill:none;stroke:currentColor;stroke-width:10.4252;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.43,
    y: -0.82,
    className: "kst0",
    width: 360,
    height: 360
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "kst1",
    d: "M165.32,319.79H75.91c-13.28,0-24.06-10.78-24.06-24.06V29.55c0-13.28,10.78-24.04,24.06-24.04h211.67 c13.28,0,24.06,10.76,24.06,24.04v182.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kst2",
    d: "M249.3,206.99c-42.03,0-76.1,34.07-76.1,76.1c0,42.01,34.07,76.08,76.1,76.08c42.01,0,76.08-34.07,76.08-76.08 C325.38,241.06,291.31,206.99,249.3,206.99z M233.41,329.11c-1.02,1.08-2.4,1.63-3.77,1.63c-1.27,0-2.52-0.44-3.52-1.36 l-38.89-35.47c-2.13-1.94-2.27-5.23-0.33-7.36c1.94-2.13,5.23-2.29,7.36-0.35l35.11,32.03l67.62-71.14 c1.98-2.11,5.28-2.19,7.36-0.19c2.09,1.98,2.17,5.28,0.19,7.36L233.41,329.11z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "kst3",
    x1: 99.56,
    y1: 78.78,
    x2: 258.55,
    y2: 78.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "kst3",
    x1: 99.56,
    y1: 134.15,
    x2: 258.55,
    y2: 134.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "kst3",
    x1: 99.56,
    y1: 189.28,
    x2: 258.55,
    y2: 189.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "kst3",
    x1: 99.56,
    y1: 252.69,
    x2: 159.89,
    y2: 252.69
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidation);
export default __webpack_public_path__ + "static/media/validation.05ef1ba340206306e8932b99aa36a7d4.svg";
export { ForwardRef as ReactComponent };